import { TE } from "@dulce/prelude";
import { handleErrorReason } from "./handleErrorReason";

export const TEtryCatchK = <I, O>(fn: (value: I) => Promise<O>) =>
  TE.tryCatchK(fn, handleErrorReason);
